<div class="container-fluid mt-3">
	<div class="section-title">System Log</div>
	<ng-template ngbModalContainer></ng-template>

	@if (pageLogs === undefined) {
		<div class="loading-status">
			<div class="logo-spin"></div>
			Loading logs...
		</div>
	}

	@if (pageLogs && !pageLogs.length) {
		<div class="loading-status">
			No logs found
		</div>
	}

	@if (pageLogs && pageLogs.length > 0) {
		<table class="log system" [class.loading]="pageLoading">
			<thead>
				<tr>
					<th>Timestamp</th>
					<th class="hide-lg">Environment</th>
					<th class="hide-lg">Instance</th>
					<th class="hide-md">IP</th>
					<th>Requester</th>
					<th>Status</th>
					<th title="HTTP Method">HTTP</th>
					<th>Path</th>
					<th title="Query"><i class="icon-help-circled"></i></th>
					<th>Duration</th>
					<th class="hide-md">DB</th>
					<th class="hide-md">Analysis</th>
					<th class="hide-md" title="Request size"><i class="icon-up-circled2"></i></th>
					<th class="hide-md" title="Response size"><i class="icon-down-circled2"></i></th>
					<th class="request-message">Message</th>
					<th title="Exception"><i class="icon-attention-circled"></i></th>
				</tr>
			</thead>
			@for (log of pageLogs; track log) {
				<tbody>
					@if (log.method !== null) {
						<tr>
							<td>
								<span title="{{log.ts}}">
									<span>{{log.ts | datetime : "local"}}</span>
								</span>
							</td>
							<td class="hide-lg"><a (click)="applyFilter('environment_name', log.environment_name)" href="javascript:void(0)">{{log.environment_name}}</a></td>
							<td class="hide-lg"><a (click)="applyFilter('ec2_instance', log.ec2_instance)" href="javascript:void(0)">{{log.ec2_instance}}</a></td>
							<td class="hide-md"><a (click)="applyFilter('remote_ip', log.remote_ip)" href="javascript:void(0)">{{log.remote_ip}}</a></td>
							<td><a (click)="applyRequesterFilter(log)" href="javascript:void(0)">{{ getRequester(log) }}</a></td>
							<td><a (click)="applyFilter('status_code', log.status_code)" href="javascript:void(0)" [style.color]="log.status_code | httpstatuscolor">{{log.status_code}}</a></td>
							<td><a (click)="applyFilter('http_method', log.method)" href="javascript:void(0)">{{log.method}}</a></td>
							<td><a (click)="applyFilter('path', log.path)" href="javascript:void(0)">{{log.path}}</a></td>
							<td>@if (log.query) {
									<i title="{{log.query}}" class="icon-help-circled"></i>
								}
							</td>
							<td><span [class.log-long-response]="log.response_time_us > 200000">{{log.response_time_us / 1000.0 | number :
						"1.0-0"}}</span>ms
							</td>
							<td class="hide-md">{{log.db_time_us ? (log.db_time_us / 1000.0 | number : "1.0-0") + "ms" : ""}}</td>
							<td class="hide-md">{{log.analysis_time_us ? (log.analysis_time_us / 1000.0 | number : "1.0-0") + "ms" : ""}}</td>
							<td class="hide-md">{{log.request_size | filesize}}</td>
							<td class="hide-md">{{log.response_size | filesize:2}}</td>
							<td class="request-message">{{log.message}}</td>
							<td>@if (log.exception && log.exception !== 'true') {
									<i (click)="showException(log)" title="{{log.exception}}" class="icon-attention-circled clickable pe-2"></i>
								}
							</td>
						</tr>
					}
					@if ((log.method === null) && (log.remote_ip !== null)) {
						<tr>
							<td>
								<span title="{{log.ts}}">
									<span>{{log.ts | datetime : "local"}}</span>
								</span>
							</td>
							<td class="hide-lg"><a (click)="applyFilter('environment_name', log.environment_name)" href="javascript:void(0)">{{log.environment_name}}</a></td>
							<td class="hide-lg"><a (click)="applyFilter('ec2_instance', log.ec2_instance)" href="javascript:void(0)">{{log.ec2_instance}}</a></td>
							<td class="hide-md"><a (click)="applyFilter('remote_ip', log.remote_ip)" href="javascript:void(0)">{{log.remote_ip}}</a></td>
							<td><a (click)="applyRequesterFilter(log)" href="javascript:void(0)">{{ getRequester(log) }}</a></td>
							<td colspan="10" class="system-message" [class.log-error]="log.exception">{{log.message}}</td>
							<td>@if (log.exception && log.exception !== 'true') {
									<i (click)="showException(log)" title="{{log.exception}}" class="icon-attention-circled clickable"></i>
								}
							</td>
						</tr>
					}
					@if ((log.method === null) && (log.remote_ip === null) && (log.response_time_us !== null)) {
						<tr>
							<td>
								<span title="{{log.ts}}">
									<span>{{log.ts | datetime : "local"}}</span>
								</span>
							</td>
							<td class="hide-lg"><a (click)="applyFilter('environment_name', log.environment_name)" href="javascript:void(0)">{{log.environment_name}}</a></td>
							<td class="hide-lg"><a (click)="applyFilter('ec2_instance', log.ec2_instance)" href="javascript:void(0)">{{log.ec2_instance}}</a></td>
							<td class="hide-md" colspan="6" class="system-message" [class.log-import-message]="log.type === 1" [class.log-error]="log.exception">{{log.message}}</td>
							<td class="hide-md" colspan="6"><span [class.log-long-response]="log.response_time_us > 5000000">{{log.response_time_us / 1000.0
						| number : "1.0-0"}}</span>ms
							</td>
							<td>@if (log.exception && log.exception !== 'true') {
									<i (click)="showException(log)" title="{{log.exception}}" class="icon-attention-circled clickable"></i>
								}
							</td>
						</tr>
					}
					@if ((log.method === null) && (log.remote_ip === null) && (log.response_time_us === null)) {
						<tr>
							<td>
								<span title="{{log.ts}}">
									<span>{{log.ts | datetime : "local"}}</span>
								</span>
							</td>
							<td class="hide-lg"><a (click)="applyFilter('environment_name', log.environment_name)" href="javascript:void(0)">{{log.environment_name}}</a></td>
							<td class="hide-lg"><a (click)="applyFilter('ec2_instance', log.ec2_instance)" href="javascript:void(0)">{{log.ec2_instance}}</a></td>
							<td colspan="12" class="system-message" [class.log-import-message]="log.type === 1" [class.log-error]="log.exception">{{log.message}}</td>
							<td>@if (log.exception && log.exception !== 'true') {
									<i (click)="showException(log)" title="{{log.exception}}" class="icon-attention-circled clickable"></i>
								}
							</td>
						</tr>
					}
				</tbody>
			}
		</table>
		<ngb-pagination [collectionSize]="totalLogs" [pageSize]="itemsPerPage" [(page)]="currentPage" (pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true"
			[rotate]="true"></ngb-pagination>
	}

	<div class="row mb-4">
		@if (filters.environment_name) {
			<div class="col-sm-6 col-md-4">
				Environment: {{filters.environment_name}}
				<i (click)="removeFilter('environment_name')" class="icon-minus-circled clickable"></i>
			</div>
		}
		@if (filters.ec2_instance) {
			<div class="col-sm-6 col-md-4">
				Instance: {{filters.ec2_instance}}
				<i (click)="removeFilter('ec2_instance')" class="icon-minus-circled clickable"></i>
			</div>
		}
		@if (filters.remote_ip) {
			<div class="col-sm-6 col-md-4">
				IP: {{filters.remote_ip}}
				<i (click)="removeFilter('remote_ip')" class="icon-minus-circled clickable"></i>
			</div>
		}
		@if (filters.status_code) {
			<div class="col-sm-6 col-md-4">
				Status: {{filters.status_code}}
				<i (click)="removeFilter('status_code')" class="icon-minus-circled clickable"></i>
			</div>
		}
		@if (filters.http_method) {
			<div class="col-sm-6 col-md-4">
				Method: {{filters.http_method}}
				<i (click)="removeFilter('http_method')" class="icon-minus-circled clickable"></i>
			</div>
		}
		@if (filters.path) {
			<div class="col-sm-6 col-md-4">
				Path: {{filters.path}}
				<i (click)="removeFilter('path')" class="icon-minus-circled clickable"></i>
			</div>
		}
		@if (filters.user?.email) {
			<div class="col-sm-6 col-md-6">
				User: {{filters.user?.email}}
				<i (click)="removeFilter('user')" class="icon-minus-circled clickable"></i>
			</div>
		}
		@if (filters.device?.serial) {
			<div class="col-sm-6 col-md-6">
				Device: {{filters.device?.serial}}
				<i (click)="removeFilter('device')" class="icon-minus-circled clickable"></i>
			</div>
		}
		@if (filters.asset?.name) {
			<div class="col-sm-6 col-md-6">
				Asset: {{filters.asset?.name}}
				<i (click)="removeFilter('asset')" class="icon-minus-circled clickable"></i>
			</div>
		}
	</div>
	<div class="row">
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_myself" (ngModelChange)="refreshTable()"> Ignore my own requests</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_users" (ngModelChange)="refreshTable()"> Ignore users</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_devices" (ngModelChange)="refreshTable()"> Ignore devices</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_anonymous" (ngModelChange)="refreshTable()"> Ignore anonymous requests</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_system" (ngModelChange)="refreshTable()"> Ignore system messages</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.ignore_import" (ngModelChange)="refreshTable()"> Ignore import messages</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.only_long_responses" (ngModelChange)="refreshTable()"> Only long responses ( &gt;=1000ms)</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.only_errors" (ngModelChange)="refreshTable()"> Only errors</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.major_errors" (ngModelChange)="refreshTable()"> Major errors</label></div>
		<div class="col-sm-4"><label><input type="checkbox" [(ngModel)]="filters.only_this_environment" (ngModelChange)="refreshTable()"> Only this environment</label></div>
	</div>
	<div class="row">
		<div class="col-sm-2">
			<button (click)="ResetFilters()" class="button">Reset</button>
		</div>
		@if (!filters.asset && !filters.user) {
			<div class="col-sm-8">
				<label>Filter to asset:</label>
				<select [(ngModel)]="selectedAsset" (ngModelChange)="FilterAsset($event)" class="form-control ms-2">
					@for (asset of assetList; track asset) {
						<option [ngValue]="asset">{{asset.fleet_name}} / {{asset.asset_name}} ({{asset.obcu_serial_number}})</option>
					}
				</select>
			</div>
		}
	</div>
</div>



<ng-template #exceptionModal let-c="close">
	<div class="modal-header">
		<h4 class="modal-title">Exception detail</h4>
		<button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="c()"></button>
	</div>
	<div class="modal-body">
		<h3>Exception</h3>
		<pre>{{selectedException | json}}</pre>
		@if (selectedExceptionStack) {
			<div>
				<h3>Stack</h3>
				<pre>{{selectedExceptionStack}}</pre>
			</div>
		}
		@if (selectedExceptionSubStack) {
			<div>
				<h3>Detail stack</h3>
				<pre>{{selectedExceptionSubStack}}</pre>
			</div>
		}
	</div>
</ng-template>